import { render, staticRenderFns } from "./TreeGiftStrip.vue?vue&type=template&id=59fa6e9d&scoped=true&"
import script from "./TreeGiftStrip.vue?vue&type=script&lang=ts&"
export * from "./TreeGiftStrip.vue?vue&type=script&lang=ts&"
import style0 from "./TreeGiftStrip.vue?vue&type=style&index=0&id=59fa6e9d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59fa6e9d",
  null
  
)

export default component.exports